import React from 'react';

import {Step1Form} from '../../Forms/Step1';

export function Step1() {
	return <Step1Form />;
}
